<div class="actions">
  <mat-form-field appearance="fill">
    <mat-label>{{ 'posts.filters.order.label' | translate }}</mat-label>
    <mat-select #sortSelect (selectionChange)="sortChange()">
      <mat-option value="age_asc">
        {{ "posts.filters.order.options.age_asc" | translate }}
      </mat-option>
      <mat-option value="age_desc">
        {{ "posts.filters.order.options.age_desc" | translate }}
      </mat-option>
      <mat-option value="sexe_asc">
        {{ "posts.filters.order.options.sexe_asc" | translate }}
      </mat-option>
      <mat-option value="sexe_desc">
        {{ "posts.filters.order.options.sexe_desc" | translate }}
      </mat-option>
      <mat-option value="price_asc">
        {{ "posts.filters.order.options.price_asc" | translate }}
      </mat-option>
      <mat-option value="price_desc">
        {{ "posts.filters.order.options.price_desc" | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button class="actions__open-filter" (click)="toggleOpenFilter()">
    <mat-icon aria-hidden="false" aria-label="open filter" svgIcon="filter"></mat-icon>
    <span class="filtres-label">Filtres</span>
  </button>
  <app-filters [(posts)]="dataSource.data" (postLayout)="postLayoutToggle($event)" (postsChange)="postFiltereded($event)" *ngIf="!activeFilter"></app-filters>
</div>

<app-posts
  [ngClass]="postLayout ? 'list' : 'grid'"
  [postsDisplay]="postsDisplay"
  [loading] = "loading"
  [scrollLoad] = "scrollLoad"
  [moderatorMode]="moderatorMode"
  (validatePost)="validatePost($event)"
  (invalidatePost)="invalidatePost($event.id)"
  (updatePost)="updatePost($event)"
  (deletePost)="deletePost($event.id)"
  (renewPost)="renewPost($event.id)"></app-posts>
<app-footer></app-footer>
